import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ShortcutKeyGroup = styled.div`
  height: ${spacing('xl')};
  white-space: nowrap;
  display: flex;
  align-items: center;
  flex-direction: row;
`;
